import React, {useContext} from "react";
import {Box, Button, Grid, List, ListItem, ListItemText, Typography} from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../../components/index";
import { isEmptyObject, removeEmpty } from "../../../../utils";
import {Link} from "react-router-dom";
import {StoreContext} from "../../../../App";


function UserEducationDocuments({ user = {} }) {
  const {auth} = useContext(StoreContext);
  const authUser = auth.user;
  user = removeEmpty(user);

  if (
    isEmptyObject(user.educationDocument) &&
    isEmptyObject(user.diplomaOfCandidateOfScience) &&
    isEmptyObject(user.phD) &&
    isEmptyObject(user.doctorOfScienceDiploma) &&
    isEmptyObject(user.associateProfessorCertificate) &&
    isEmptyObject(user.professorCertificate) &&
    isEmptyObject(user.seniorScientistCertificate) &&
    isEmptyObject(user.certificateOfEnglish) &&
    isEmptyObject(user.certificationTraining)
  ) return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography variant={"b"} component={"b"} sx={{ fontWeight: 500 }}>Нічого не знайдено</Typography>
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Button component={Link} to={`/cabinet/users/${user._id}/edit`} variant={"contained"}>Додати</Button>
        </Box>
      </Box>
  );

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      <Grid container sx={{ padding: "10px 0" }}>
        {authUser?._id === user._id && (
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}>
              <Button component={Link} to={`/cabinet/users/${user._id}/edit`}
                      variant={"contained"}>Редагувати</Button>
            </Grid>
        )}
        <Grid item sx={{ textAlign: "left" }} xs={12} sm={12} md={12}>
          {!isEmptyObject(user.educationDocument) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Документ про освіту (диплом):"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.educationDocument?.seriesNumber && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія номер:`}
                      secondary={user.educationDocument?.seriesNumber}
                    />
                  </ListItem>
                )}
                {user.educationDocument?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.educationDocument?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.educationDocument?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.educationDocument?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.educationDocument?.specialty && (
                  <ListItem>
                    <ListItemText
                      primary={`Спеціальність:`}
                      secondary={user.educationDocument?.specialty}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.diplomaOfCandidateOfScience) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Диплом кандидата наук:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.diplomaOfCandidateOfScience?.seriesNumber && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія номер:`}
                      secondary={user.diplomaOfCandidateOfScience?.seriesNumber}
                    />
                  </ListItem>
                )}
                {user.diplomaOfCandidateOfScience?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.diplomaOfCandidateOfScience?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.diplomaOfCandidateOfScience?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.diplomaOfCandidateOfScience?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.diplomaOfCandidateOfScience?.dissertationTopic && (
                  <ListItem>
                    <ListItemText
                      primary={`Тема дисертації:`}
                      secondary={user.diplomaOfCandidateOfScience?.dissertationTopic}
                    />
                  </ListItem>
                )}
                {user.diplomaOfCandidateOfScience?.speciality && (
                  <ListItem>
                    <ListItemText
                      primary={`Найменування спеціальності:`}
                      secondary={user.diplomaOfCandidateOfScience?.speciality}
                    />
                  </ListItem>
                )}
                {user.diplomaOfCandidateOfScience?.codeAndName && (
                  <ListItem>
                    <ListItemText
                      primary={`Шифр спеціальності:`}
                      secondary={user.diplomaOfCandidateOfScience?.codeAndName}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.phD) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Диплом доктора філософії:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.phD?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.phD?.series}
                    />
                  </ListItem>
                )}
                {user.phD?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.phD?.number}
                    />
                  </ListItem>
                )}
                {user.phD?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.phD?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.phD?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.phD?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.phD?.dissertationTopic && (
                  <ListItem>
                    <ListItemText
                      primary={`Тема дисертації:`}
                      secondary={user.phD?.dissertationTopic}
                    />
                  </ListItem>
                )}
                {user.phD?.speciality && (
                  <ListItem>
                    <ListItemText
                      primary={`Найменування спеціальності:`}
                      secondary={user.phD?.speciality}
                    />
                  </ListItem>
                )}
                {user.phD?.codeAndName && (
                  <ListItem>
                    <ListItemText
                      primary={`Шифр спеціальності:`}
                      secondary={user.phD?.codeAndName}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.doctorOfScienceDiploma) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Диплом доктора наук:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.doctorOfScienceDiploma?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.doctorOfScienceDiploma?.series}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.doctorOfScienceDiploma?.number}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.doctorOfScienceDiploma?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.doctorOfScienceDiploma?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.dissertationTopic && (
                  <ListItem>
                    <ListItemText
                      primary={`Тема дисертації:`}
                      secondary={user.doctorOfScienceDiploma?.dissertationTopic}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.speciality && (
                  <ListItem>
                    <ListItemText
                      primary={`Найменування спеціальності:`}
                      secondary={user.doctorOfScienceDiploma?.speciality}
                    />
                  </ListItem>
                )}
                {user.doctorOfScienceDiploma?.codeAndName && (
                  <ListItem>
                    <ListItemText
                      primary={`Шифр спеціальності:`}
                      secondary={user.doctorOfScienceDiploma?.codeAndName}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.associateProfessorCertificate) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Атестат доцента:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.associateProfessorCertificate?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.associateProfessorCertificate?.series}
                    />
                  </ListItem>
                )}
                {user.associateProfessorCertificate?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.associateProfessorCertificate?.number}
                    />
                  </ListItem>
                )}
                {user.associateProfessorCertificate?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.associateProfessorCertificate?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.associateProfessorCertificate?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.associateProfessorCertificate?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.associateProfessorCertificate?.departmentWasAssigned && (
                  <ListItem>
                    <ListItemText
                      primary={`Спеціальність:`}
                      secondary={user.associateProfessorCertificate?.departmentWasAssigned}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.professorCertificate) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Атестат професора:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.professorCertificate?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.professorCertificate?.series}
                    />
                  </ListItem>
                )}
                {user.professorCertificate?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.professorCertificate?.number}
                    />
                  </ListItem>
                )}
                {user.professorCertificate?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.professorCertificate?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.professorCertificate?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.professorCertificate?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.professorCertificate?.departmentWasAssigned && (
                  <ListItem>
                    <ListItemText
                      primary={`Спеціальність:`}
                      secondary={user.professorCertificate?.departmentWasAssigned}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.seniorScientistCertificate) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Атестат старшого наукового співробітника:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.seniorScientistCertificate?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.seniorScientistCertificate?.series}
                    />
                  </ListItem>
                )}
                {user.seniorScientistCertificate?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.seniorScientistCertificate?.number}
                    />
                  </ListItem>
                )}
                {user.seniorScientistCertificate?.issuedBy && (
                  <ListItem>
                    <ListItemText
                      primary={`Ким видано:`}
                      secondary={user.seniorScientistCertificate?.issuedBy}
                    />
                  </ListItem>
                )}
                {user.seniorScientistCertificate?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.seniorScientistCertificate?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
                {user.seniorScientistCertificate?.departmentWasAssigned && (
                  <ListItem>
                    <ListItemText
                      primary={`Спеціальність:`}
                      secondary={user.seniorScientistCertificate?.departmentWasAssigned}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.certificateOfEnglish) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"}
                          variant={"b"}>{"Сертифікат з англійської мови (на рівні не нижче В2):"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.certificateOfEnglish?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Серія:`}
                      secondary={user.certificateOfEnglish?.series}
                    />
                  </ListItem>
                )}
                {user.certificateOfEnglish?.number && (
                  <ListItem>
                    <ListItemText
                      primary={`Номер:`}
                      secondary={user.certificateOfEnglish?.number}
                    />
                  </ListItem>
                )}
                {user.certificateOfEnglish?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.certificateOfEnglish?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
          {!isEmptyObject(user.certificationTraining) && (
            <Grid item sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
              <Typography component={"b"} variant={"b"}>{"Відомості про підвищення кваліфікації:"}</Typography>
              <List sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gridAutoFlow: "dense"
              }}>
                {user.certificationTraining?.series && (
                  <ListItem>
                    <ListItemText
                      primary={`Найменування закладу:`}
                      secondary={user.certificationTraining?.series}
                    />
                  </ListItem>
                )}
                {user.certificationTraining?.documentType && (
                  <ListItem>
                    <ListItemText
                      primary={`Вид документа:`}
                      secondary={user.certificationTraining?.documentType}
                    />
                  </ListItem>
                )}
                {user.certificationTraining?.topic && (
                  <ListItem>
                    <ListItemText
                      primary={`Тема:`}
                      secondary={user.certificationTraining?.topic}
                    />
                  </ListItem>
                )}

                {user.certificationTraining?.numberOfStudyСredits && (
                  <ListItem>
                    <ListItemText
                      primary={`Кількість кредитів (годин):`}
                      secondary={user.certificationTraining?.numberOfStudyСredits}
                    />
                  </ListItem>
                )}
                {user.certificationTraining?.dateOfIssue && (
                  <ListItem>
                    <ListItemText
                      primary={`Дата видачі:`}
                      secondary={new Date(user.certificationTraining?.dateOfIssue).toLocaleDateString()}
                    />
                  </ListItem>
                )}
              </List>
            </Grid>
          )}
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
}

export default UserEducationDocuments;
